define(function(require) {

    const ReCaptcha = require('modules/google-recaptcha/recaptcha');
    const fieldUtil = require('modules/google-recaptcha/util');
    const core = require('core');
    const _ = require('underscore');

    return {
        initRecaptcha({ selector, operation }) {
            this.recaptchasQuantity = 0;
            this.submitRecaptcha = new ReCaptcha({ selector, operation });
            this.submitEvents = {
                RECAPTCHA_SHOW: _.uniqueId('event_'),
                RECAPTCHA_HIDE: _.uniqueId('event_')
            };
        },

        subscribeOnRecaptcha() {
            this.listenTo(core, {
                [`recaptcha:show ${this.submitEvents.RECAPTCHA_SHOW}`]: this.onShow,
                [`recaptcha:hide ${this.submitEvents.RECAPTCHA_HIDE}`]: this.onHide
            });
        },

        onShow(options = {}) {
            const { input, renderOptions } = options;

            if (input && renderOptions && this.el.contains(input)) {
                const { isUpdated } = fieldUtil.showRecaptcha(input, renderOptions);

                if (isUpdated) {
                    return;
                }
            }

            this.recaptchasQuantity += 1;
        },

        onHide(options = {}) {
            const { input } = options;

            if (input && !this.el.contains(input)) {
                return;
            }

            this.recaptchasQuantity > 0 && (this.recaptchasQuantity -= 1);
        },

        showSubmitRecaptcha({ onValidate, onError }) {
            const { submitRecaptcha: instance } = this;

            core.trigger(this.submitEvents.RECAPTCHA_SHOW);

            return instance.render({
                onValidate: ({ token }) => {
                    core.trigger(this.submitEvents.RECAPTCHA_HIDE);
                    instance.remove();
                    onValidate && onValidate(token);
                },
                onError: (err) => {
                    const { isScriptLoadingError } = err;

                    if (isScriptLoadingError) {
                        core.trigger(this.submitEvents.RECAPTCHA_HIDE);
                        instance.remove();
                    }

                    onError && onError(err);
                }
            });
        },

        getRecaptchaError() {
            return this.recaptchasQuantity > 0
                ? { translation: 'playtech.mobile.system.recaptcha.error.captchaNotPassed' }
                : null;
        }
    };

});
